export const SOCIAL_COMPONENT_VALUE = "social";

export const createSocialSection = () => ({
  value: SOCIAL_COMPONENT_VALUE,
  label: "Social",
  href: "/social",
  icon: "faComments",
  title: "Social",
  displayOnFooter: true,
  external_link: false,
  url: "",
  htmlContent: "",
  content: {
    type: "cardWithImage",
    image: "",
    location: "",
    link: "",
  },
});
